import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Link } from '@mui/material';
import { requestCallback } from '../../../store/auctions/action';
import { setUser } from '../../../store/user/action';
import { getItem, setItem } from '../../../utils/helpers/storage-crud';
import { COOKIE_KEYS } from '../../../constants/app-constants';
import { trackDealerEvents } from '../../../tracking';

const NewDealerScreen = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state) || {};
    const { dealerCode, mobilePhone: phone } = user || {};
    const [checkoutAppCtaClicked, setCheckoutAppCtaClicked] = useState(false);
    const callbackRequested = getItem(COOKIE_KEYS.CALLBACK_REQUESTES) || false;

    useEffect(() => {
        trackDealerEvents('requestCallbackPageLoad');
    }, []);

    const getHeading = () => {
        if ( callbackRequested ) return 'Thanks for showing interest!';
        if ( checkoutAppCtaClicked ) return 'Thanks for showing interest!';
        return 'Your bidding rights are not active.';
    };

    const getMessage = () => {
        if ( callbackRequested ) return 'Our representative will get in touch with you soon to guide you through the onboarding process';
        if ( checkoutAppCtaClicked ) return 'Our listings are available onty for our registered users. You can register with us by scheduling a callback to experience full fealures of our app';
        return 'In order to start bidding, please schedule a callback from our representative';
    };

    const onCallbackRequest = () => {
        trackDealerEvents('requestCallbackClick', { dealer_code: dealerCode, phone });
        requestCallback(dealerCode).then((resp) => {
            dispatch(setUser(resp));
            setItem(true, COOKIE_KEYS.CALLBACK_REQUESTES);
        });
    };

    const handleClick = () => {
        trackDealerEvents('justCheckingClick', { dealer_code: dealerCode, phone });
        setCheckoutAppCtaClicked(true);
    };

    return (
        <div className='items-center font-semibold justify-center text-lg'>
            <Box
                className='border-border'
                sx={{
                textAlign: 'center',
            }}>
                <div>
                    <h3 className='text-lg'>{getHeading()}</h3>
                    <h3 className='text-lg'>{getMessage()}</h3>
                    {!callbackRequested && <Button
                        variant="contained"
                        color='primary'
                        className='w-100 text-base py-2 font-bold'
                        onClick={onCallbackRequest}
                    >Request Callback
                    </Button>}
                    {!callbackRequested && !checkoutAppCtaClicked && <p color='primary' >
                        <Link onClick={handleClick} underline="always">
                            {'No, I want to checkout the app!'}
                        </Link>
                    </p>}
                </div>
            </Box>
            <div>
                <h3 className='text-lg'>What to expect?</h3>
                <h3 className='text-lg'>With Cars24 Partner app, you can source used cars with our</h3>
                <ul className='text-lg'>
                    <li>Seamless auction experience</li>
                    <li>Certified inspection report</li>
                    <li>Wide selection of cars</li>
                    <li>Dedicated customer support</li>
                </ul>
                <h3 className='text-center text-lg'>If you are in the business of pre-owned cars, request a callback now and gain access to Cars24 Partner App's exclusive curated listings.</h3>
            </div>
        </div>
    );
};

NewDealerScreen.propTypes = {
    back: PropTypes.bool,
    close: PropTypes.bool,
    text: PropTypes.string,
    handleBack: PropTypes.func,
    handleClose: PropTypes.func
};

export default NewDealerScreen;
